import {Box} from '@primer/react-brand'

import type {AppStoreButton} from '../../../../schemas/contentful/contentTypes/appStoreButton'
import {getAnalyticsEvent} from '../../../../lib/utils/analytics'
import styles from './StoreButton.module.css'

type AppStoreLink = {
  link: AppStoreButton['fields']['link']
  analyticsLabel: string
  analyticsLocation: string
}

export function GooglePlayStore({link, analyticsLabel, analyticsLocation}: AppStoreLink): React.ReactElement {
  return (
    <Box className={styles.googleImageBox}>
      <a
        href={link.fields.href}
        aria-label={link.fields.text}
        target={link.fields.openInNewTab ? '_blank' : '_self'}
        rel="noreferrer"
        {...getAnalyticsEvent(
          {
            action: `google_play_store`,
            tag: 'button',
            location: analyticsLocation,
            context: 'CTAs',
          },
          {context: false},
        )}
        data-ref={`${analyticsLabel}-google-play-store-button-${link.sys.id}`}
      >
        <svg
          viewBox="0 0 135 40"
          xmlns="http://www.w3.org/2000/svg"
          fillRule="evenodd"
          clipRule="evenodd"
          strokeLinejoin="round"
          strokeMiterlimit="2"
        >
          <title>Google Play</title>
          <path
            d="M130 40H5c-2.75 0-5-2.25-5-5V5c0-2.75 2.25-5 5-5h125c2.75 0 5 2.25 5 5v30c0 2.75-2.25 5-5 5z"
            fillRule="nonzero"
          />
          <path
            d="M130 .001H5C2.25.001 0 2.251 0 5v30.001c0 2.749 2.25 5 5 5h125c2.75 0 5-2.251 5-5V5c0-2.749-2.25-4.999-5-4.999zm0 .799c2.316 0 4.2 1.885 4.2 4.2v30.001c0 2.315-1.884 4.2-4.2 4.2H5a4.205 4.205 0 01-4.2-4.2V5C.8 2.685 2.684.8 5 .8h125z"
            fill="#a6a6a6"
            fillRule="nonzero"
          />
          <path
            d="M47.418 10.244c0 .838-.248 1.505-.745 2.003-.565.591-1.3.887-2.204.887-.866 0-1.603-.3-2.208-.9-.607-.601-.909-1.345-.909-2.234 0-.888.302-1.632.909-2.233.605-.601 1.342-.901 2.208-.901.429 0 .841.084 1.231.252.391.168.704.391.939.67l-.528.528c-.397-.475-.944-.712-1.642-.712-.632 0-1.178.222-1.639.666-.461.444-.691 1.021-.691 1.73 0 .71.23 1.287.691 1.731a2.282 2.282 0 001.639.666c.67 0 1.228-.223 1.676-.67.29-.291.458-.696.502-1.215h-2.178v-.721h2.907c.028.157.042.307.042.453z"
            fill="#fff"
            fillRule="nonzero"
          />
          <path
            d="M47.418 10.244h-.1c-.001.819-.24 1.454-.716 1.932l-.001.001v.001c-.547.571-1.249.855-2.132.856-.843-.001-1.549-.288-2.138-.871-.588-.584-.878-1.297-.879-2.163.001-.866.291-1.578.879-2.162.589-.583 1.295-.871 2.138-.872.416 0 .813.081 1.192.244.379.163.678.377.901.642l.077-.064-.071-.071-.527.528.07.071.077-.064c-.416-.499-.999-.75-1.719-.748a2.378 2.378 0 00-1.708.694c-.482.463-.723 1.072-.722 1.802-.001.731.24 1.34.722 1.803a2.378 2.378 0 001.708.694c.692.001 1.282-.234 1.746-.699.31-.311.486-.742.532-1.278l.01-.108h-2.188v-.521h2.807v-.1l-.098.018c.027.151.04.295.04.435h.2c0-.152-.014-.309-.044-.471l-.014-.082h-3.091v.921h2.278v-.1l-.099-.009c-.044.503-.204.882-.474 1.153-.43.428-.957.64-1.605.641a2.177 2.177 0 01-1.569-.638c-.441-.426-.66-.97-.661-1.659.001-.688.22-1.232.661-1.658.445-.428.96-.637 1.569-.638.676.001 1.186.225 1.566.676l.07.084.604-.605.065-.065-.059-.07a2.576 2.576 0 00-.975-.698 3.197 3.197 0 00-1.271-.26 3.121 3.121 0 00-2.279.93c-.624.617-.939 1.393-.938 2.304-.001.911.314 1.687.938 2.305.622.618 1.39.93 2.279.929.925.001 1.694-.306 2.276-.918l-.072-.069.071.07c.518-.517.775-1.217.774-2.073h-.1zM52.027 7.738h-2.732V9.64h2.464v.721h-2.464v1.902h2.732V13h-3.503V7h3.503v.738z"
            fill="#fff"
            fillRule="nonzero"
          />
          <path
            d="M52.027 7.738v-.1h-2.832V9.74h2.464v.521h-2.464v2.102h2.732v.537h-3.303V7.1h3.303v.638h.1v-.1.1h.1V6.9h-3.703v6.2h3.703V12.163h-2.732v-1.702h2.464V9.54h-2.464V7.838h2.732v-.1h-.1zM55.278 13h-.771V7.738h-1.676V7h4.123v.738h-1.676V13z"
            fill="#fff"
            fillRule="nonzero"
          />
          <path
            d="M55.278 13v-.1h-.671V7.638h-1.676V7.1h3.923v.538h-1.676V13h.1v-.1.1h.1V7.838h1.676V6.9h-4.323v.938h1.676V13.1h.971V13h-.1zM59.938 7h.77v6h-.77z"
            fill="#fff"
            fillRule="nonzero"
          />
          <path
            d="M59.938 13h.1V7.1h.57v5.8h-.67v.1h.1-.1v.1h.87V6.9h-.97v6.2h.1V13zM64.128 13h-.772V7.738h-1.675V7h4.123v.738h-1.676V13z"
            fill="#fff"
            fillRule="nonzero"
          />
          <path
            d="M64.128 13v-.1h-.672V7.638h-1.675V7.1h3.923v.538h-1.676V13h.1v-.1.1h.1V7.838h1.676V6.9h-4.323v.938h1.675V13.1h.972V13h-.1zM69.779 11.723c.444.449.987.674 1.63.674.642 0 1.186-.225 1.63-.674.444-.45.667-1.024.667-1.723 0-.698-.223-1.272-.667-1.722a2.206 2.206 0 00-1.63-.674c-.643 0-1.186.225-1.63.674-.444.45-.666 1.024-.666 1.722 0 .699.222 1.273.666 1.723zm3.83.502c-.59.607-1.323.909-2.2.909-.877 0-1.611-.302-2.199-.909-.59-.606-.884-1.348-.884-2.225s.294-1.618.884-2.224c.588-.607 1.322-.91 2.199-.91.872 0 1.603.305 2.196.914.592.609.888 1.349.888 2.22 0 .877-.295 1.619-.884 2.225z"
            fill="#fff"
            fillRule="nonzero"
          />
          <path
            d="M69.779 11.723l-.071.07c.46.468 1.035.705 1.701.704a2.302 2.302 0 001.701-.704c.463-.468.697-1.073.696-1.793.001-.719-.233-1.324-.696-1.792a2.302 2.302 0 00-1.701-.704 2.302 2.302 0 00-1.701.704c-.463.468-.696 1.073-.695 1.792-.001.72.232 1.325.695 1.793l.071-.07.071-.071c-.424-.431-.636-.974-.637-1.652.001-.677.213-1.22.637-1.652v.001a2.1 2.1 0 011.559-.645 2.1 2.1 0 011.558.644v.001c.426.431.638.974.639 1.651-.001.678-.213 1.221-.639 1.652a2.098 2.098 0 01-1.558.645 2.1 2.1 0 01-1.559-.645l-.071.071zm3.83.502l-.072-.07c-.573.588-1.274.878-2.128.879-.854-.001-1.556-.291-2.128-.879l-.003-.002.003.002c-.572-.589-.854-1.3-.855-2.155.001-.854.283-1.565.855-2.154.572-.588 1.274-.879 2.128-.88.849.001 1.548.293 2.124.884.575.592.859 1.301.86 2.15-.001.855-.285 1.566-.856 2.155l.144.14c.606-.623.913-1.395.912-2.295.001-.894-.307-1.664-.916-2.29-.61-.627-1.373-.945-2.268-.944-.9-.001-1.666.315-2.271.94-.608.623-.913 1.395-.912 2.294-.001.9.304 1.672.912 2.295l.003.003-.003-.003c.605.625 1.371.94 2.271.939.9.001 1.665-.314 2.272-.939l-.072-.07zM75.575 13V7h.938l2.916 4.668h.033l-.033-1.156V7h.772v6h-.805l-3.051-4.893h-.033l.033 1.156V13h-.77z"
            fill="#fff"
            fillRule="nonzero"
          />
          <path
            d="M75.575 13h.1V7.1h.783l2.916 4.668h.191l-.036-1.258V7.1h.572v5.8h-.649l-3.051-4.893h-.192l.036 1.258V12.9h-.67v.1h.1-.1v.1h.87V9.262l-.033-1.158-.1.003v.1h.033v-.1l-.085.053 3.081 4.94h.96V6.9h-.972v3.613l.033 1.158.1-.003v-.1h-.033v.1l.085-.053L76.569 6.9h-1.094v6.2h.1V13zM106.936 30.001h1.866V17.499h-1.866v12.502zm16.807-7.999l-2.139 5.42h-.064l-2.22-5.42h-2.01l3.329 7.576-1.898 4.213h1.947l5.13-11.789h-2.075zm-10.582 6.578c-.612 0-1.464-.305-1.464-1.061 0-.965 1.062-1.335 1.978-1.335.821 0 1.206.177 1.705.418a2.262 2.262 0 01-2.219 1.978zm.225-6.851c-1.351 0-2.75.595-3.329 1.914l1.656.692c.354-.692 1.013-.917 1.705-.917.965 0 1.946.579 1.962 1.608v.129c-.338-.193-1.061-.483-1.946-.483-1.785 0-3.603.981-3.603 2.815 0 1.672 1.464 2.75 3.104 2.75 1.255 0 1.946-.563 2.381-1.222h.064v.965h1.801v-4.793c0-2.22-1.656-3.458-3.795-3.458zm-11.532 1.795H99.2v-4.285h2.654c1.395 0 2.187 1.155 2.187 2.143 0 .969-.792 2.142-2.187 2.142zm-.048-6.025h-4.471v12.502H99.2v-4.737h2.606c2.068 0 4.101-1.497 4.101-3.882 0-2.386-2.033-3.883-4.101-3.883zM77.424 28.583c-1.288 0-2.368-1.08-2.368-2.562 0-1.498 1.08-2.593 2.368-2.593 1.273 0 2.272 1.095 2.272 2.593 0 1.482-.999 2.562-2.272 2.562zm2.143-5.88h-.064c-.419-.5-1.225-.951-2.24-.951-2.126 0-4.076 1.869-4.076 4.269 0 2.385 1.95 4.237 4.076 4.237 1.015 0 1.821-.451 2.24-.966h.064v.612c0 1.627-.87 2.497-2.272 2.497-1.143 0-1.852-.822-2.142-1.514l-1.627.676c.467 1.128 1.707 2.514 3.769 2.514 2.192 0 4.044-1.289 4.044-4.431V22.01h-1.772v.693zm3.061 7.298h1.869V17.499h-1.869v12.502zm4.624-4.125c-.049-1.643 1.273-2.481 2.223-2.481.742 0 1.37.371 1.579.903l-3.802 1.578zm5.8-1.417c-.354-.951-1.434-2.707-3.641-2.707-2.191 0-4.012 1.724-4.012 4.253 0 2.385 1.804 4.253 4.221 4.253 1.95 0 3.078-1.192 3.545-1.885l-1.45-.966c-.483.709-1.144 1.176-2.095 1.176-.951 0-1.627-.435-2.062-1.289l5.687-2.352-.193-.483zm-45.309-1.402v1.804h4.318c-.129 1.015-.467 1.756-.983 2.272-.628.628-1.611 1.321-3.335 1.321-2.658 0-4.736-2.143-4.736-4.801 0-2.658 2.078-4.801 4.736-4.801 1.434 0 2.481.564 3.255 1.289l1.272-1.273c-1.079-1.031-2.513-1.82-4.527-1.82-3.641 0-6.702 2.964-6.702 6.605 0 3.641 3.061 6.605 6.702 6.605 1.966 0 3.448-.644 4.608-1.852 1.192-1.193 1.563-2.868 1.563-4.221a5.92 5.92 0 00-.097-1.128h-6.074zm11.079 5.526c-1.289 0-2.4-1.063-2.4-2.578 0-1.53 1.111-2.577 2.4-2.577s2.4 1.047 2.4 2.577c0 1.515-1.111 2.578-2.4 2.578zm0-6.831c-2.352 0-4.269 1.788-4.269 4.253 0 2.449 1.917 4.253 4.269 4.253 2.352 0 4.269-1.804 4.269-4.253 0-2.465-1.917-4.253-4.269-4.253zm9.313 6.831c-1.288 0-2.4-1.063-2.4-2.578 0-1.53 1.112-2.577 2.4-2.577 1.289 0 2.401 1.047 2.401 2.577 0 1.515-1.112 2.578-2.401 2.578zm0-6.831c-2.352 0-4.269 1.788-4.269 4.253 0 2.449 1.917 4.253 4.269 4.253 2.353 0 4.27-1.804 4.27-4.253 0-2.465-1.917-4.253-4.27-4.253z"
            fill="#fff"
            fillRule="nonzero"
          />
          <path
            d="M20.509 42.39l-.074-.071c-.291-.308-.463-.786-.463-1.405v.145-22.121.152c0-.67.201-1.176.536-1.478l12.39 12.389L20.509 42.39zm-.537-23.453zm.005-.164v-.002.002zm0-.007v-.001.001z"
            fill="url(#_Linear1)"
            transform="translate(-10 -10)"
          />
          <path
            d="M37.027 34.279l.094-.054 4.893-2.78c.467-.265.778-.586.933-.927-.155.341-.466.662-.933.928l-4.893 2.78-.094.053zm.001-.147l-4.13-4.131 4.13-4.13 4.986 2.833c.634.359.989.823 1.048 1.297v.002c-.059.472-.414.936-1.048 1.296l-4.986 2.833z"
            fill="url(#_Linear2)"
            transform="translate(-10 -10)"
          />
          <path
            d="M21.392 42.862a1.29 1.29 0 01-.883-.325v-.001a1.288 1.288 0 00.883.326zm.001-.147a1.282 1.282 0 01-.884-.325l12.389-12.389 4.13 4.131-14.515 8.248c-.401.228-.782.335-1.12.335zm-.887-.181a1.281 1.281 0 01-.065-.063l.065.063z"
            fill="url(#_Linear3)"
            transform="translate(-10 -10)"
          />
          <path
            d="M32.898 30.001l-12.39-12.389a1.29 1.29 0 01.883-.325c.339 0 .72.108 1.122.337l14.515 8.247-4.13 4.13zm4.223-4.223l-14.608-8.3c-.402-.229-.783-.337-1.122-.337h-.004.005c.339 0 .719.108 1.121.336l14.608 8.3v.001z"
            fill="url(#_Linear4)"
            transform="translate(-10 -10)"
          />
          <path
            d="M11.485 32.859c.314-.018.662-.126 1.028-.333l14.514-8.247-14.514 8.247c-.366.208-.714.316-1.028.333zm-.976-.322l-.003-.003.003.003zm-.068-.066l-.006-.006.006.006z"
            fillRule="nonzero"
          />
          <path d="M37.027 34.279l.094-.054-.094.054z" fill="url(#_Linear5)" transform="translate(-10 -10)" />
          <path
            d="M21.393 42.862c-.346 0-.648-.113-.884-.326v.001l-.003-.003-.065-.063-.006-.006.074-.075c.236.213.538.326.884.325.338 0 .719-.107 1.12-.335l14.515-8.248.093.093-.094.054-14.514 8.247c-.366.207-.714.315-1.028.333a1.437 1.437 0 01-.092.003z"
            fill="url(#_Linear6)"
            transform="translate(-10 -10)"
          />
          <path
            d="M10.435 32.465c-.291-.308-.463-.786-.463-1.405v-.001c0 .62.172 1.098.463 1.405v.001z"
            fillRule="nonzero"
          />
          <path
            d="M20.435 42.464c-.291-.307-.463-.785-.463-1.405v-.145c0 .619.172 1.097.463 1.405l.074.071-.074.074z"
            fill="url(#_Linear7)"
            transform="translate(-10 -10)"
          />
          <path d="M20.435 42.465v-.001l.074-.074-.074.075z" fill="url(#_Linear8)" transform="translate(-10 -10)" />
          <path d="M32.947 20.518c.077-.168.115-.342.115-.515l.001-.001c0 .174-.039.347-.116.516z" fillRule="nonzero" />
          <path
            d="M37.121 34.225l-.093-.093 4.986-2.833c.634-.36.989-.824 1.048-1.296 0 .173-.038.347-.115.515-.155.341-.466.662-.933.927l-4.893 2.78z"
            fill="url(#_Linear9)"
            transform="translate(-10 -10)"
          />
          <path
            d="M33.063 20.001h-.001c0-.523-.349-1.046-1.048-1.443l-4.893-2.78v-.001l4.893 2.781c.699.397 1.049.92 1.049 1.443z"
            fill="#404040"
            fillRule="nonzero"
          />
          <path
            d="M43.062 30.001c-.059-.474-.414-.938-1.048-1.297l-4.986-2.833.093-.093 4.893 2.78c.699.397 1.048.92 1.048 1.443z"
            fill="url(#_Linear10)"
            transform="translate(-10 -10)"
          />
          <path
            d="M9.972 8.938v-.001.001zm.004-.162l.001-.003-.001.003zm.001-.005v-.005.005zm0-.006c.058-1.027.616-1.62 1.406-1.624-.342.002-.64.114-.874.325l-.003.003a1.533 1.533 0 00-.071.069c-.262.278-.428.694-.458 1.227z"
            fill="#404040"
            fillRule="nonzero"
          />
          <path
            d="M19.972 19.09v-.153c0-.055.002-.109.004-.161l.001-.003v-.008c.03-.533.196-.949.458-1.227l.073.074c-.335.302-.536.808-.536 1.478zm.534-1.621l.003-.003-.003.003z"
            fill="url(#_Linear11)"
            transform="translate(-10 -10)"
          />
          <path d="M11.383 7.141h.004-.004z" fill="#404040" fillRule="nonzero" />
          <path
            d="M37.028 25.871l-14.515-8.247c-.402-.229-.783-.337-1.122-.337a1.29 1.29 0 00-.883.325l-.073-.074c.023-.024.047-.047.071-.069l.003-.003c.234-.211.532-.323.874-.325h.008c.339 0 .72.108 1.122.337l14.608 8.3-.093.093z"
            fill="url(#_Linear12)"
            transform="translate(-10 -10)"
          />
          <defs>
            <linearGradient
              id="_Linear1"
              x1="0"
              y1="0"
              x2="1"
              y2="0"
              gradientUnits="userSpaceOnUse"
              gradientTransform="scale(-23.734 23.734) rotate(-45 .282 2.011)"
            >
              <stop offset="0" stopColor="#00a0ff" />
              <stop offset="1" stopColor="#00e2ff" />
            </linearGradient>
            <linearGradient
              id="_Linear2"
              x1="0"
              y1="0"
              x2="1"
              y2="0"
              gradientUnits="userSpaceOnUse"
              gradientTransform="matrix(-24.197 0 0 24.197 43.834 30.001)"
            >
              <stop offset="0" stopColor="#ffdf00" />
              <stop offset="1" stopColor="#ff9c00" />
            </linearGradient>
            <linearGradient
              id="_Linear3"
              x1="0"
              y1="0"
              x2="1"
              y2="0"
              gradientUnits="userSpaceOnUse"
              gradientTransform="scale(-32.1851 32.1851) rotate(-45 .67 1.808)"
            >
              <stop offset="0" stopColor="#ff3a44" />
              <stop offset="1" stopColor="#c31162" />
            </linearGradient>
            <linearGradient
              id="_Linear4"
              x1="0"
              y1="0"
              x2="1"
              y2="0"
              gradientUnits="userSpaceOnUse"
              gradientTransform="scale(14.372 -14.372) rotate(45 1.456 1.099)"
            >
              <stop offset="0" stopColor="#31a070" />
              <stop offset="1" stopColor="#00ef75" />
            </linearGradient>
            <linearGradient
              id="_Linear5"
              x1="0"
              y1="0"
              x2="1"
              y2="0"
              gradientUnits="userSpaceOnUse"
              gradientTransform="matrix(-24.197 0 0 24.197 43.834 30.001)"
            >
              <stop offset="0" stopColor="#ccb300" />
              <stop offset="1" stopColor="#cc7c00" />
            </linearGradient>
            <linearGradient
              id="_Linear6"
              x1="0"
              y1="0"
              x2="1"
              y2="0"
              gradientUnits="userSpaceOnUse"
              gradientTransform="scale(-32.1851 32.1851) rotate(-45 .67 1.808)"
            >
              <stop offset="0" stopColor="#cc2d36" />
              <stop offset="1" stopColor="#9c0e4d" />
            </linearGradient>
            <linearGradient
              id="_Linear7"
              x1="0"
              y1="0"
              x2="1"
              y2="0"
              gradientUnits="userSpaceOnUse"
              gradientTransform="scale(-23.734 23.734) rotate(-45 .282 2.011)"
            >
              <stop offset="0" stopColor="#008cdf" />
              <stop offset="1" stopColor="#00c6df" />
            </linearGradient>
            <linearGradient
              id="_Linear8"
              x1="0"
              y1="0"
              x2="1"
              y2="0"
              gradientUnits="userSpaceOnUse"
              gradientTransform="scale(-32.1851 32.1851) rotate(-45 .67 1.808)"
            >
              <stop offset="0" stopColor="#df333b" />
              <stop offset="1" stopColor="#aa0e56" />
            </linearGradient>
            <linearGradient
              id="_Linear9"
              x1="0"
              y1="0"
              x2="1"
              y2="0"
              gradientUnits="userSpaceOnUse"
              gradientTransform="matrix(-24.197 0 0 24.197 43.834 30.001)"
            >
              <stop offset="0" stopColor="#dfc400" />
              <stop offset="1" stopColor="#df8900" />
            </linearGradient>
            <linearGradient
              id="_Linear10"
              x1="0"
              y1="0"
              x2="1"
              y2="0"
              gradientUnits="userSpaceOnUse"
              gradientTransform="matrix(-24.197 0 0 24.197 43.834 30.001)"
            >
              <stop offset="0" stopColor="#ffe83f" />
              <stop offset="1" stopColor="#ffb53f" />
            </linearGradient>
            <linearGradient
              id="_Linear11"
              x1="0"
              y1="0"
              x2="1"
              y2="0"
              gradientUnits="userSpaceOnUse"
              gradientTransform="scale(-23.734 23.734) rotate(-45 .282 2.011)"
            >
              <stop offset="0" stopColor="#3fb8ff" />
              <stop offset="1" stopColor="#3fe9ff" />
            </linearGradient>
            <linearGradient
              id="_Linear12"
              x1="0"
              y1="0"
              x2="1"
              y2="0"
              gradientUnits="userSpaceOnUse"
              gradientTransform="scale(14.372 -14.372) rotate(45 1.456 1.099)"
            >
              <stop offset="0" stopColor="#64b895" />
              <stop offset="1" stopColor="#3ff497" />
            </linearGradient>
          </defs>
        </svg>
      </a>
    </Box>
  )
}
